// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609071129/js/" + chunkId + "." + {"44":"e0352c03","225":"9d7031c8","481":"0b89a16a","486":"0c89a325","770":"8eacf5e8"}[chunkId] + ".0.3452845110177727.chunk.js";
};